import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

//Material UI Imports
import {

  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

const Quality = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(261)); 
      console.log(permission);

    axios.post("/qualities/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.qualities);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


const editItem = (item)=>{
  window.location.href = "/qualities-edit/"+item;
} 
 
const deleteItem = (item) => {
  Swal.fire({
    title: 'Do you really want to delete this record?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'DELETE'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/qualities/delete/${item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/qualities";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
  });
}
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const FarmNameCell = ({ row }) => {
    return (
      <a href={`/qualities-view/${row.original.id}`} className="btn btn-link">
        {row.original.analysis_name}
      </a>
    );
  };
  
//   // ✅ Add PropTypes validation
  FarmNameCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        analysis_name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  const getS3SignedUrl = (fileKey) => {
  if (!fileKey) return null;

  AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
  });

  const s3 = new AWS.S3();
  const params = {
    Bucket: AWS_BUCKET,
    Key: fileKey,
    Expires: 60, // URL expires in 60 seconds
  };

  return s3.getSignedUrl('getObject', params);
};
const FileDownloadCell = ({ row }) => {
  const fileKey = row.original.file;
  if (!fileKey) return 'N/A';

  const url = getS3SignedUrl(fileKey);
  const filename = fileKey.split('/').pop();

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      download={filename}
      className="btn btn-sm btn-outline-primary"
    >
      Download
    </a>
  );
};

FileDownloadCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      file: PropTypes.string,
    }).isRequired,
  }).isRequired,
};



const columns =
 [
  {
    header: 'Analysis name',
    accessorFn: (row) => `${row.analysis_name}`,
    Cell: FarmNameCell,
  

  },
    {
      accessorKey: 'lab_name', //normal accessorKey
      header: 'Lab Name',
    }, 
    {
      accessorKey: 'ram_lot_or_farm', //normal accessorKey
      header: 'RM Lot or Farm',
    }, 
   
       {
      accessorKey: 'product', //normal accessorKey
      header: 'Product',
    }, 
   
    {
      accessorKey: 'product_type', //normal accessorKey
      header: 'Product Type',
    }, 
    {
      header: 'Farm',
      accessorFn: (row) => `${(row.farm_detail)?row.farm_detail.name:""} `,
    },
    {
      header: 'Processing Line',
      accessorFn: (row) => `${(row.location)?row.location.title:""} `,
    },
    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },
    // {
    //   header: 'File',
    //   accessorKey: 'file',
    //   Cell: ({ row }) => {
    //     const fileKey = row.original.file;
    //     if (!fileKey) return 'N/A';

    //     const url = getS3SignedUrl(fileKey);
    //     const filename = fileKey.split('/').pop();

    //     return (
    //       <a
    //         href={url}
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         download={filename}
    //         className="btn btn-sm btn-outline-primary"
    //       >
    //         Download
    //       </a>
    //     );
    //   },
    // },
    {
  header: 'File',
  accessorKey: 'file',
  Cell: FileDownloadCell,
},

    {
      header: 'Price',
      accessorFn: (row) => row.price.toFixed(2)+`${(row.quality_currency)?row.quality_currency.symbol:""} `,
    },
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   
  ];

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Lab Analysis</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Lab Analysis</li>
                </ul>
              </div>
              <div className="col-auto">
              {permission && permission.add === 1 && (
                 <Link to="/qualities-add" className="btn btn-primary me-1">
                 <i className="fas fa-plus"></i>
               </Link>
                )} 
               
              </div>
            </div>
          </div>

          <div className="row">
          
            <div className="col-sm-12">
              <div className="card card-table">
                    {permission && permission.list === 1 && (
                      <div className="card-body">
                        <div className="table-responsive">
                        <MaterialReactTable columns={columns} data={data} 
                          // enableColumnFilterModes
                          enableColumnOrdering
                          // enableGrouping
                          enablePinning
                          enableRowActions
                        
                          renderRowActionMenuItems={({ row }) => [
                            permission?.update === 1 && (
                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                Edit
                              </MenuItem>
                            ),
                            permission?.delete === 1 && (
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                Delete
                              </MenuItem>
                            ),
                          ]}
                        />
                        </div>
                      </div>
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Quality;
